export default "__VITE_ASSET__Dxp5I_K0__"